import React from 'react';

import { checkGoalModuleEnabled } from 'utils/helpers/moduleAccess';

import MSTeamHubView from '../common/MSTeamHubView';
import NotEnabled from '../common/NotEnabled';

const MSTeamsEmployeeGoalsList = (props) => {
  const type = 'GOAL';

  if (!checkGoalModuleEnabled()) {
    return <NotEnabled />;
  }

  return <MSTeamHubView type={type} />;
};

export default MSTeamsEmployeeGoalsList;
